import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import countryCodesAndFlags from './countryCodesAndFlags';
import styles from './countriesDropdown.module.css';

const searchCountryByText = (options, query) => {
  const toMatch = query.toUpperCase();
  return options.filter(
    ({ key, value }) => key.toUpperCase().includes(toMatch)
      || value.toUpperCase().includes(toMatch),
  );
};

const CountriesDropDownSelection = ({ handleChange }) => (
  <Dropdown
    name='countryCallingCode'
    className={styles.countries}
    placeholder='Country'
    search={searchCountryByText}
    selection
    options={countryCodesAndFlags}
    onChange={handleChange}
  />
);

export default CountriesDropDownSelection;
